// 会社編集フォームの法人番号検索モーダル(#3380)。
// 検索は法人番号検索と同じ search JSON を使い、選択したら会社編集フォームの法人番号欄へ値をセットする。
import { corporateNumberValid } from './corporate_number';

// fomantic の modal は sprockets 側の jQuery(window.jQuery) に載っていて、webpack 側の $ には無い。
// モーダルの開閉だけは window 側の jQuery で行う(home.js / export_construction_ledger.js と同じ)。
const fomanticModal = () => (window.jQuery || window.$)('#cns-modal');

$(function () {
  const $modal = $('#cns-modal');
  const $openButton = $('#cns-modal-open');
  if ($modal.length === 0 || $openButton.length === 0) return;

  const searchUrl = $modal.data('search-url');
  const $number = $('#cns-m-number');
  const $name = $('#cns-m-name');
  const $address = $('#cns-m-address');
  const $result = $('#cns-m-result');

  function escapeHtml(value) {
    return $('<div>').text(value == null ? '' : value).html();
  }

  function renderRecords(records) {
    if (!records || records.length === 0) {
      $result.html('<div class="ui message">該当する法人が見つかりませんでした。</div>');
      return;
    }
    let rows = '';
    records.forEach(function (r) {
      const closedLabel = r.closed ? ' <span class="ui red label">閉鎖</span>' : '';
      rows += '<tr>'
        + '<td>' + escapeHtml(r.name) + closedLabel + '</td>'
        + '<td>' + escapeHtml(r.prefecture_name) + escapeHtml(r.city_name) + escapeHtml(r.street_number) + '</td>'
        + '<td>' + escapeHtml(r.corporate_number) + '</td>'
        + '<td><button type="button" class="ui tiny primary button cns-m-pick" data-number="' + escapeHtml(r.corporate_number) + '">選択</button></td>'
        + '</tr>';
    });
    $result.html(
      '<table class="ui celled table"><thead><tr>'
      + '<th>企業名</th><th>所在地</th><th>法人番号</th><th></th>'
      + '</tr></thead><tbody>' + rows + '</tbody></table>'
    );
  }

  function renderResult(data) {
    if (data.valid === false) {
      $result.html('<div class="ui warning message">法人番号のチェックデジットが一致しません。</div>');
      return;
    }
    if (data.too_many) {
      const count = data.count ? (data.count + '件が該当します。') : '該当が多すぎます。';
      $result.html('<div class="ui warning message">' + escapeHtml(count) + '条件を絞ってください（住所を加えると絞れます）。</div>');
      return;
    }
    renderRecords(data.records);
  }

  function runSearch() {
    const number = ($number.val() || '').replace(/[^\d]/g, '');
    if (number.length === 13 && !corporateNumberValid(number)) {
      $result.html('<div class="ui warning message">法人番号のチェックデジットが一致しません。</div>');
      return;
    }
    const params = {
      corporate_number: number,
      name: $name.val() || '',
      address: $address.val() || ''
    };
    if (number.length === 0 && params.name.trim() === '' && params.address.trim() === '') {
      $result.empty();
      return;
    }
    $.ajax({ type: 'GET', url: searchUrl, data: params, dataType: 'json' })
      .done(renderResult)
      .fail(function () { $result.html('<div class="ui negative message">検索に失敗しました。</div>'); });
  }

  $openButton.on('click', function () {
    fomanticModal().modal({ autofocus: false }).modal('show');
  });

  $('#cns-m-search').on('click', runSearch);
  $modal.on('keydown', 'input', function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      runSearch();
    }
  });

  // 選択したら会社編集フォームの法人番号欄へ値をセットしてモーダルを閉じる
  $result.on('click', '.cns-m-pick', function () {
    const number = $(this).data('number').toString();
    $('#company_corporate_number').val(number);
    fomanticModal().modal('hide');
  });
});
